/**
 * apiConfig.js — API access helpers.
 *
 * All requests use relative paths (same origin): this works with CRA's dev
 * proxy locally (→ localhost:3001) and with the production container, which
 * serves the frontend build and the API from the same origin.
 */

/**
 * fetch() wrapper that injects the X-Access-Code header required by the
 * server-side access gate.
 * The code is read from REACT_APP_ACCESS_CODE at build time (default "1212").
 * It must match the server's ACCESS_CODE env var (also default "1212").
 * Usage: apiFetch("/api/search", { method: "POST", ... })
 */
const ACCESS_CODE = process.env.REACT_APP_ACCESS_CODE || "1212";

export function apiFetch(path, options) {
  const merged = {
    ...options,
    headers: {
      "X-Access-Code": ACCESS_CODE,
      ...(options && options.headers ? options.headers : {}),
    },
  };
  return fetch(path, merged);
}

/** Session-storage helpers for the security gate */
const UNLOCK_KEY = "figmaref.unlocked";

export function isUnlocked() {
  return sessionStorage.getItem(UNLOCK_KEY) === "1";
}

export function setUnlocked() {
  sessionStorage.setItem(UNLOCK_KEY, "1");
}
